import { gql } from 'graphql-tag';

export const GET_PROJECTS_QUERY = gql`
    query {
        entries(section: "projects", orderBy: "postDate desc") {
            id
            url
            title

            ... on default_Entry {
                projectFeaturedImage @transform(width: 1080, height: 608, immediately: false) {
                    id
                    title
                    width
                    height
                    mimeType
                    focalPoint
                    hasFocalPoint
                    srcset(sizes: ["360w", "720w", "1080w"])
                }

                projectThumbnail @transform(width: 1080, height: 608, immediately: false) {
                    id
                    title
                    width
                    height
                    mimeType
                    focalPoint
                    hasFocalPoint
                    srcset(sizes: ["360w", "720w", "1080w"])
                }
            }
        }
    }
`;
